import React from "react";
import { Box, Typography, Container, Grid, Divider } from "@mui/material";
import LeftSideNavbar from "../components/leftSideNavbar.component";
import ProductMaterialsDataTable from "../components/SupplierDetails/ProductMaterialsDataTable.component";
import { PageStyles } from "../styles";
import TopBreadcrumbs from "../components/topBreadcrumbs.component";

const TodoPage = () => {
  return (
    <Box sx={PageStyles.containerBox}>
      <LeftSideNavbar />
      <Box sx={PageStyles.containerBoxExceptNavbar}>
        <Box sx={{
          ...PageStyles.firstSectionWithBreadcrumbsAndName,
          position: 'sticky',
          top: 0,
          zIndex: 100,
          borderBottom: '1px solid #E0E0E0',
        }}>
          <TopBreadcrumbs />
          <Grid container justifyContent="space-between">
            <Grid item>
              <Typography gutterBottom sx={PageStyles.name}>
                To Do
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Divider />
        <Container sx={{ py: 4, maxWidth: "100% !important" }}>
          <ProductMaterialsDataTable />
        </Container>
      </Box>
    </Box>
  );
};

export default TodoPage;
